import styled from "styled-components";
import { AuthoryColorSchemes } from "../ProfileHero/V3ProfileHero.types";
import { V3HeadlineH1, V3Paragraph } from "../Typography";
import { media, theme } from "../../theme/theme";
import { getV3ContentDimension } from "../../utils/getV3ContentDimension";
import { ProfileView } from "@authory-packages/core";
import { AuthoryColorSchemeProps, UserThemableHeading, UserThemableParagraph } from "../ReusableStyledComponents/FontSetUtilities";


export const CollectionEditCoverPos = styled.div`
    position: absolute;
    bottom: 20px;
    right: 20px;
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 15px;
        }
    }
`;

export const CollectionHeaderMetadata = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 14px;

    > div {
        &:nth-child(2) {
            margin-left: 10px;
        }
    }

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        margin-bottom: 42px;
    }
`;

export const CollectionHeaderContent = styled.div <{ $colorVariant: AuthoryColorSchemes, $editMode: boolean, $viewType: ProfileView }>`
    padding: ${({ $editMode }) => $editMode ? "30px 18px 75px" : "30px 18px"};
    max-width: ${({ $viewType }) => `${getV3ContentDimension($viewType, false, undefined)}px`};
    margin: 0 auto;
    position: relative;
    z-index: 1;

    ${media.phone} {
        padding: 85px 18px;
    }
`;

export const UserThemableCollectionTitle = styled(V3HeadlineH1)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;


export const UserThemableCollectionDescription = styled(V3Paragraph)<AuthoryColorSchemeProps>`
    ${UserThemableParagraph}
`;